<script lang="ts" setup>

  import { BngAccountDropdown } from '../account-dropdown'

  const { user } = storeToRefs(useUserStore())
  const dropdownDisplayed = ref(false)

  const firstName = computed(() => user.value?.data?.first_name ?? 'Anonyme')
</script>
<template>
  <div
    class="c-profile-menu"
    @mouseleave="dropdownDisplayed = false"
  >
    <Button
      type="secondary"
      @mouseover="dropdownDisplayed = true"
    >
      <div class="button-content">
        <SvgIcon
          icon="account"
          :width="28"
          :height="28"
        />
        <span class="button-text"> {{ firstName }}</span>
      </div>
    </Button>
    <div
      v-show="dropdownDisplayed"
      class="dropdown"
      @click="dropdownDisplayed = false"
    >
      <div class="triangle" />
      <div class="content">
        <BngAccountDropdown />
      </div>
    </div>
  </div>
</template>
<style scoped>

.c-profile-menu {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;

  .c-button {
    display: flex;
    width: 4em;
    flex: 1 1 auto;
    align-items: center;
    padding-bottom: 0;

    .button-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .c-icon {
        margin-bottom: 0;
      }

      .button-text {
        display: inline-block;
        overflow: hidden;
        width: 75px;
        color: white;
        font-family: Open-Sans, sans-serif;
        font-size: 0.75em;
        font-weight: 600;
        text-overflow: ellipsis;
      }
    }
  }

  .dropdown {
    position: absolute;
    z-index: 1;
    top: calc(100% - 6px);
    right: -1em;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .triangle {
      position: relative;
      z-index: 2;
      right: calc(3.5em - 8px);
      width: 16px;
      border-width: 0 8px 6px;
      border-style: solid;
      border-right-color: transparent;
      border-bottom-color: white;
      border-left-color: transparent;
    }

    .content {
      position: relative;
      z-index: 1;
      width: 300px;
      padding: 2em;
      border-radius: 0 0 0.25em 0.25em;
      background-color: white;
      box-shadow: 0 0 25px 0 rgb(0 0 0 / 15%);
    }
  }

  @media screen and (width >= 1024px) {
    .dropdown {
      top: calc(100% - 10px);

      .triangle {
        right: calc(3.5em - 12px);
        width: 24px;
        border-width: 0 12px 10px;
      }
    }
  }
}
</style>
